import CustomFile from "../utils/customFile";
import {
    renameJobAdderSelects,
    setupJobAdderSelects,
    handleJobAdderScroll
} from '../utils/jobAdderHelpers';

export default class JobsList {
    constructor(query) {
        this.el = document.querySelector(query);
        if (!this.el) return;
        this.customFile = new CustomFile(this.el);

        this.init();
    }

    init() {
        this.observer = new MutationObserver(() => {
            renameJobAdderSelects(this.el);
            setupJobAdderSelects(this.el);
            this.setupApplicationFile();
            handleJobAdderScroll(this.el);
        });

        this.observer.observe(this.el, {
            childList: true,
            subtree: true,
        });
    }

    setupApplicationFile() {
        const resume = this.el.querySelector('#CandidateResume');

        if (!resume) return;

        const field = resume.closest('.ja-field');

        if (!field) return;

        field.setAttribute('data-custom-file', '');

        this.customFile.init();
    }
}